var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "50 200 1550 1000",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { transform: "matrix(1.78875 0 0 1.78833 83 37)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_1_", d: "M-315.5-236.5h1431v1073h-1431z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_1_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_2_)" } },
          [
            _c("path", {
              staticStyle: { fill: "#e6e6e6" },
              attrs: {
                d: "m672.9 476.9 12.2-3.8c1-.7 2.1-1.1 3.1-2l-19 6.1c1.3 0 2.5 0 3.7-.3zm-8.6 0 27.6-9c.5-.4.9-1 1.4-1.4l-30.9 9.8c.6.4 1.3.5 1.9.6zm-4.9-1.2 36.1-11.6c.4-.3.5-.8 1-1.2L658.4 475c.4.5.7.5 1 .7zm-2.8-1.8 41.5-13.3c.2-.3.4-.8.7-1.1L656 473.2c.1.4.4.6.6.7zm-2.1-2.1 45.2-14.4c.2-.3.2-.7.4-1.1L654 471.2c.3.2.4.5.5.6zm-1.3-2.2 48-15.3c0-.3.2-.7.2-1.1l-48.7 15.6c.2.3.3.6.5.8zm-1.2-2.4 49.9-16c0-.3.1-.7.2-1.1l-50.4 16c.1.6.2.8.3 1.1zm-.8-2.4 51.4-16.5c0-.3.1-.7.1-1L650.8 464c.1.2.2.5.4.8zm-.5-2.9c.1.1-.1.2 0 .3l52.3-16.7c0-.3.1-.7.1-1L651 461.1c-.1.2-.2.5-.3.8zm2.7-3.7c-.1.1-.2.3-.4.3l50.1-16c0-.3-.1-.5 0-.9l-48.8 15.7c-.4.3-.6.7-.9.9zm2.4-3.2 46.8-15c0-.3-.1-.5-.2-.9L656.3 454c0 .3-.2.6-.5 1zm1.6-3.3 45.1-14.4c-.1-.3-.1-.5-.2-.9l-44.4 14.3c-.4.5-.4.8-.5 1zm.7-2.9 43.7-13.9c-.1-.3-.2-.4-.2-.9l-43.1 13.9c-.3.3-.4.6-.4.9zm.3-2.9 42.5-13.5c-.1-.3-.2-.4-.3-.8L658.4 445v.9zm-.3-2.7 41.3-13.2c-.1-.3-.2-.4-.3-.8l-41 13.1v.9zm-.5-2.5 40.3-13c-.1-.3-.4-.5-.5-.7l-40.2 12.9.4.8zm37.8-15.7-39.2 12.4c.1.3.2.4.3.8l39.5-12.7c0-.1-.3-.3-.6-.5zm-2.3-2-38.2 12.2c.1.3.4.5.5.7l38.5-12.3c-.3 0-.6-.4-.8-.6zm-3.1-1.7-36.5 11.6c.1.3.2.4.3.8l37.2-12c-.3-.1-.5-.3-1-.4zm-3.8-1.4c-.1.1-.2-.1-.3 0l-32.2 10.3c-.1.2-.1.7-.1 1l34.1-10.9c-.6-.1-1.1-.3-1.5-.4zm-8.2-.4-20.9 6.7-2.1 1.5 26.4-8.4c-1 .1-2.3.1-3.4.2z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                d: "M734.7 291.8c1.5 4.6-.2 9.5-2.5 13.8-6.2 11.7-16.3 21.3-28.3 26.9-6.7 3.2-13.9 5-20.7 7.9-20 8.3-36.2 24.9-44 45.1 2.3-14-5-27.8-14-38.9-8.8-11-19.5-21-25.9-33.6-5.5-10.9-5.6-27.1 5.5-32.3 8.1-3.8 18.2.4 26.5-3.1 2.9-1.3 5.6-3.9 5.5-7.1-.4-8.1-16.4-7.5-16.8-15.6-.4-9.3 24-6.6 20.9-15.4-1.3-3.7-6.5-4.8-8.3-8.3-1.9-3.5-1.7-8.4 1.4-10.9 4-3.3 10.2-.7 15.3-1.9 5.8-1.3 9.5-7.2 10.7-13.1s.5-11.9 1.4-17.8c2.1-14.5 14-27.1 28.3-30.1 14.3-3.1 30.2 3.7 38 16.2 3.2 5.1 4.9 12 1.5 16.9-2.9 4.1-9.3 6.9-8.7 11.9.7 6.9 13.4 7.5 13.6 14.4.2 8.1-16.4 8.1-15.9 16.2.2 3.6 4 5.7 6.3 8.5 4.4 5.2 2.6 14.3-3.4 17.6-2.4 1.3-5.2 1.9-7.1 3.7-4.8 4.7-.1 13 5.6 16.5 5.6 3.3 13 6.1 15.1 12.5z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "M692.7 292.3c3.4-1.9 7-3.6 9.7-6.4 5.6-6.1 5.2-15.3 5.7-23.6.4-8.3 3.4-18 11.4-20.2 6.7-1.9 15.1 2.2 20-2.6 1.9-1.7 2.6-4.4 3.9-6.6 5.7-9.5 20.6-8.7 28.9-1.4 8.2 7.3 11.4 18.7 14.1 29.4 1 3.9 1.1 9.4-2.7 10.5-3.7 1-7.4-3.6-10.9-2.2-2.8 1.1-3.1 5.1-2 8.1 1 2.8 2.7 5.8 2.1 8.8-1.3 5.7-9.3 6-15 4.5-5.7-1.5-13-3.1-16.3 1.9 3.6 11.5 6.7 25.4-1.4 34.5-9.3 10.4-26.4 9.3-40.3 10.6-25.8 2.4-44 22.1-58.5 43.6-.8-36.1 19.8-71.7 51.3-88.9z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "M660.4 364.7h-.2c-.3-.1-.4-.4-.3-.7 13.1-40.1 34-67.9 72.1-96 7.1-5.2 28.5-14.1 37.8-14.8.2 0 .5.2.5.5s-.2.5-.5.5c-8.8.8-30.3 9.6-37.1 14.6-38 27.9-58.7 55.6-71.7 95.4-.1.3-.4.5-.6.5zM680.6 247.3l-4.4-12c-1.5-.1-3.2.1-4.7.7l4.7 12.9c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-4.7-12.7c-1.4.9-2.6 2.1-3.6 3.4l3.9 10.7c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-3.1-8.4c-1.7 4.4-1.9 9.9.1 15.4 0 .1.1.2.1.3-1 .5-2.1 1.2-2.9 2-2.7 2-6.2 5.3-7.4 10.2l1.3.3c1.1-4.4 4.4-7.5 6.9-9.3.9-.7 1.7-1.2 2.7-1.7 2.1 4.6 5.5 8.3 9.2 10.3l-2.9-8c-.2-.8.1-1.5.9-1.7s1.5.1 1.7.9l3.8 10.3c1.6.4 3.3.5 4.9.2l-4.4-12c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l4.5 12.1c1.4-.7 2.7-1.6 3.8-2.7l-4-10.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l3.5 9.4c1.1-1.6 2.1-3.4 2.9-5.2l-2.2-5.9c-.2-.8.1-1.5.9-1.7.8-.2 1.5.1 1.7.9l1.2 3.2c2.2-5.2 3.6-10.4 5.5-12-3.1-.7-7.3-3.5-12-6.1l1.5 4c.2.8-.1 1.5-.9 1.7-.8.2-1.5-.1-1.7-.9l-2.5-6.9c-1.9-.9-3.7-1.5-5.6-2l3.8 10.6c.2.8-.1 1.5-.9 1.7-.5-.1-1.2-.4-1.6-1.1z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#d6d7d8" },
              attrs: { d: "M342.9 381h121.8v135.5H342.9z" },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: { d: "M267.4 512.1h272.7v10.5H267.4z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_3_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "1125.59",
                  y1: "1979.09",
                  x2: "6477.141",
                  y2: "1979.09",
                  gradientTransform: "matrix(.1789 0 0 .1788 -65.148 -58.75)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_3_)" },
              attrs: { d: "M136.2 121.9h535.2v346.5H136.2z" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M145.6 130.5H662v285.4H145.6z" },
            }),
            _c("path", {
              staticStyle: { fill: "#a1c3fc" },
              attrs: {
                transform: "rotate(-45.009 384.559 442.708)",
                d: "M379.6 437.7h9.9v9.9h-9.9z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                transform: "rotate(-45.009 403.721 442.693)",
                d: "M398.8 437.7h9.9v9.9h-9.9z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                transform: "rotate(-45.009 422.883 442.723)",
                d: "M417.9 437.8h9.9v9.9h-9.9z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                d: "M61.4 450.3c-.2 4.8 2.7 9.2 6.1 12.7 9.2 9.7 21.5 16.4 34.6 18.6 7.3 1.2 14.8 1.2 22.3 2.1 21.6 2.7 41.8 14.5 54.8 32-6-13-2.5-28.4 3.2-41.5 5.7-13.1 13.4-25.5 16.2-39.5 2.4-12-1.9-27.8-14-29.9-9-1.5-17.7 5.3-26.6 4-3.2-.4-6.6-2.3-7.2-5.5-1.7-8 14-11.7 12.1-19.7-2.1-9.2-25.1 0-24.3-9.3.3-3.9 5-6.3 5.9-10.3s-.5-8.6-4.3-10.2c-4.8-2.1-10 2.1-15.3 2.3-6 .3-11.1-4.5-13.9-9.8s-3.7-11.5-6.1-16.9c-5.9-13.5-20.7-22.6-35.5-21.7-14.7.9-28.4 11.7-32.6 25.9-1.7 5.8-1.6 13 3.1 16.9 3.9 3.3 10.8 4.1 11.7 9.2 1.2 6.9-11 10.9-9.4 17.7 1.9 8 18.1 3.5 19.8 11.5.8 3.6-2.4 6.7-3.8 9.9-2.8 6.2 1.3 14.5 8 16.2 2.6.7 5.6.3 8 1.6 5.9 3.3 3.6 12.6-1 17.5-5 5-11.4 9.4-11.8 16.2z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "M102.5 439.7c-3.8-.9-7.8-1.6-11.1-3.7-7.1-4.5-9.2-13.5-11.8-21.4-2.6-7.9-8.1-16.6-16.4-16.6-7 0-14.1 6.2-20.1 2.8-2.3-1.3-3.7-3.6-5.6-5.3-8-7.6-22.4-2.9-28.4 6.3s-6 21.2-5.9 32.3c.1 4 1.4 9.4 5.5 9.4 3.8 0 6.2-5.5 10-5 3.1.3 4.4 4.3 4.1 7.3-.2 3.1-1.1 6.3.3 9.1 2.7 5.2 10.7 3.4 15.7.3s11.8-6.4 16.3-2.5c-.4 12.1.3 26.5 10.6 33.1 11.8 7.5 28.2 2 41.9-.4 25.7-4.6 48.7 9.7 68.4 26.7-8.9-35.2-38.4-64.2-73.5-72.4z",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M178.9 517.2c-8.7-22.8-15.7-46.3-21.1-70.1" },
            }),
            _c("ellipse", {
              staticClass: "st9",
              attrs: {
                transform: "rotate(-12.909 157.63 444.801)",
                cx: "157.6",
                cy: "444.7",
                rx: "12.4",
                ry: "4.7",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M157.2 444.3c-2.9-13.5-5.3-27.1-7.2-40.8" },
            }),
            _c("ellipse", {
              staticClass: "st9",
              attrs: {
                transform: "rotate(-18.504 149.48 400.33)",
                cx: "149.5",
                cy: "400.3",
                rx: "15",
                ry: "5.6",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M149.4 399.9c-1.4-11.4-2.5-22.7-3.3-34.1" },
            }),
            _c("ellipse", {
              staticClass: "st9",
              attrs: {
                transform: "matrix(.9999 -.0106 .0106 .9999 -3.827 1.577)",
                cx: "146.9",
                cy: "361.9",
                rx: "15",
                ry: "5.6",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M145.9 361c-.4-8.6-.7-17.4-.8-26.1" },
            }),
            _c("ellipse", {
              staticClass: "st9",
              attrs: {
                transform: "matrix(.9999 -.0106 .0106 .9999 -3.494 1.558)",
                cx: "145.2",
                cy: "330.4",
                rx: "20.1",
                ry: "7.5",
              },
            }),
            _c("path", {
              staticClass: "st8",
              attrs: { d: "M145.1 329c.1-5.8.2-11.6.4-17.4" },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                d: "m132.8 484.9 4.4-12c1.5-.1 3.2.1 4.7.7l-4.7 12.9c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l4.7-12.7c1.4.9 2.6 2.1 3.6 3.4l-3.9 10.7c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l3.1-8.4c1.7 4.4 1.9 9.9-.1 15.4 0 .1-.1.2-.1.3 1 .5 2.1 1.2 2.9 2 2.7 2 6.2 5.3 7.4 10.2l-1.3.3c-1.1-4.4-4.4-7.5-6.9-9.3-.9-.7-1.7-1.2-2.7-1.7-2.1 4.6-5.5 8.3-9.2 10.3l2.9-8c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.8 10.3c-1.6.4-3.3.5-4.9.2l4.4-12c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-4.5 12.1c-1.4-.7-2.7-1.6-3.8-2.7l4-10.9c.2-.8-.1-1.5-.9-1.7-.8-.2-1.5.1-1.7.9l-3.5 9.4c-1.1-1.6-2.1-3.4-2.9-5.2l2.2-5.9c.2-.8-.1-1.5-.9-1.7s-1.5.1-1.7.9l-1.2 3.2c-2.2-5.2-3.6-10.4-5.5-12 3.1-.7 7.3-3.5 12-6.1l-1.5 4c-.2.8.1 1.5.9 1.7s1.5-.1 1.7-.9l2.5-6.9c1.9-.9 3.7-1.5 5.6-2l-3.8 10.6c-.2.8.1 1.5.9 1.7.5 0 1.3-.3 1.6-1.1z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "m109.6 136-8.2-1c-.8.1-1.5.1-2.3.3l12.8 1.4c-.9-.1-1.6-.5-2.3-.7zm5 2.3L96 136.2c-.4.1-.8.3-1.2.4l20.7 2.4c-.3-.3-.6-.5-.9-.7zm2.5 2-24.2-2.7c-.3.1-.5.3-.9.4l25.5 2.9c-.1-.3-.3-.4-.4-.6zm1.2 1.8L90.4 139c-.2.1-.4.3-.7.4l28.7 3.3c.1-.3 0-.5-.1-.6zm.6 1.8-30.3-3.5c-.2.1-.3.3-.5.5l31 3.5c-.2-.2-.2-.4-.2-.5zm.3 1.6L87 141.8c-.1.2-.3.3-.4.5l32.6 3.7v-.5zm0 1.8-33.5-3.8c-.1.2-.2.3-.4.5l33.8 3.9c.1-.3.1-.4.1-.6zm-.1 1.6L84.6 145c-.1.2-.2.3-.3.5l34.8 3.9v-.5zm-.6 1.8c0-.1.1-.1.1-.2l-35-4c-.1.2-.2.3-.3.5l34.9 4c.1 0 .2-.1.3-.3zm-2.5 1.5c.1 0 .2-.1.3-.1l-33.6-3.8c-.1.2-.1.3-.2.5l32.8 3.7c.3-.1.5-.2.7-.3zm-2.3 1.2-31.4-3.6c-.1.2-.1.3-.1.5l31 3.5c.1-.1.3-.2.5-.4zm-1.7 1.5-30.2-3.5c0 .2-.1.3-.1.5l29.8 3.4c.2-.1.3-.3.5-.4zm-1.2 1.5L81.5 153c0 .2 0 .3-.1.5l28.9 3.3c.2 0 .3-.2.5-.4zm-.9 1.7-28.5-3.3v.5l28.3 3.3c0-.2.1-.4.2-.5zm-.7 1.6-27.7-3.2v.5l27.5 3.2c.1-.2.2-.4.2-.5zm-.3 1.6-27.1-3.1c0 .2.1.4.1.5l27 3.1v-.5zm-26.3-.7 26.3 3.1v-.5L82.4 160c0 .1.1.4.2.6zm.9 1.7 25.7 2.9c0-.2-.1-.4-.1-.5l-25.9-2.9c0 .1.2.3.3.5zm1.3 1.9 24.5 2.8v-.5l-25-2.8c.1 0 .3.3.5.5zm1.8 1.8c.1 0 .1.1.2.1l21.6 2.5c.1-.1.2-.3.3-.5L86 165.5c.2.1.4.3.6.5zm4.7 2.3 14 1.6c.5-.1 1.1-.2 1.6-.3l-17.7-2.1c.7.3 1.5.6 2.1.8zM687.1 497.3l12.8.5c1.2-.2 2.4-.3 3.5-.8l-20-.7c1.4.3 2.5.7 3.7 1zm-8.1-3 29 1c.7-.2 1.1-.5 1.9-.9l-32.4-1.2c.5.6.9.9 1.5 1.1zm-4-2.7 37.9 1.3c.5-.2.8-.5 1.3-.8l-40-1.5c.2.5.5.6.8 1zm-2.2-2.8 43.6 1.5c.3-.2.7-.5 1-.8l-44.9-1.6c-.1.5.2.8.3.9zm-1.2-2.6 47.5 1.7c.3-.2.4-.5.8-.9l-48.5-1.7c.2.4.2.7.2.9zm-.6-2.5 50.3 1.9c.1-.3.4-.5.7-.9l-51.1-1.9c.1.3.1.6.1.9zm-.2-2.7 52.4 2c.1-.3.3-.5.7-.9L671 480c-.2.6-.2.7-.2 1zm0-2.5 53.9 2c.1-.3.3-.5.4-.9l-54.5-2c.2.2.2.5.2.9zm.7-3c0 .2-.1.2-.1.3l54.8 2.1c.1-.3.3-.5.4-.9l-54.6-2c-.2.2-.4.3-.5.5zm3.7-2.5c-.2 0-.3.2-.5.2l52.6 1.9c.1-.3.1-.5.3-.9l-51.2-1.9c-.6.3-.9.5-1.2.7zm3.4-2.2 49.1 1.9c.1-.3.1-.5.1-.9l-48.5-1.7c-.1.2-.4.4-.7.7zm2.5-2.5 47.3 1.7c0-.3.1-.5.1-.9l-46.6-1.6c-.5.3-.6.6-.8.8zm1.7-2.5 45.7 1.7c0-.3 0-.5.1-.9l-45.2-1.6c-.4.3-.5.5-.6.8zm1.1-2.6 44.5 1.6c0-.3 0-.5-.1-.9l-44.2-1.7c.1.4 0 .8-.2 1zm.9-2.6 43.3 1.6c0-.3 0-.5-.1-.9l-43-1.6c-.1.3-.2.7-.2.9zm.3-2.6 42.4 1.5c0-.3-.2-.7-.2-.9l-42.1-1.5c-.2.3-.1.6-.1.9zm40.8-2-41.2-1.6c0 .3 0 .5.1.9l41.5 1.5c.1-.2-.1-.5-.4-.8zm-1.5-2.6-40.1-1.5c0 .3.2.7.2.9l40.5 1.5c-.3-.3-.4-.6-.6-.9zm-2.3-2.8-38.2-1.5c0 .3 0 .5.1.9l39.1 1.4c-.4-.1-.7-.4-1-.8zm-3-2.6c-.2 0-.2-.1-.3-.1l-33.8-1.3c-.1.2-.3.5-.4.9l35.7 1.3c-.6-.1-.9-.5-1.2-.8zm-7.6-2.9-21.8-.9c-.9.2-1.6.4-2.5.7l27.6 1.1c-1.1-.3-2.3-.7-3.3-.9z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(1.68111 0 0 1.6841 487 346)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_4_", d: "M-131.3-71.3h648v351h-648z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_5_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_4_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_5_)" } }, [
          _c("ellipse", {
            staticClass: "st11",
            attrs: { cx: "28", cy: "79", rx: "47.1", ry: "47.2" },
          }),
          _c("ellipse", {
            staticClass: "st11",
            attrs: { cx: "178", cy: "41", rx: "47.1", ry: "47.2" },
          }),
          _c("ellipse", {
            staticClass: "st11",
            attrs: { cx: "306", cy: "139", rx: "47.1", ry: "47.2" },
          }),
          _c("ellipse", {
            staticClass: "st3",
            attrs: { cx: "306", cy: "139", rx: "25.4", ry: "25.5" },
          }),
          _c("ellipse", {
            staticClass: "st11",
            attrs: { cx: "124.5", cy: "158.5", rx: "29.4", ry: "29.5" },
          }),
          _c("ellipse", {
            staticClass: "st11",
            attrs: { cx: "302.5", cy: "41.5", rx: "29.4", ry: "29.5" },
          }),
          _c("circle", {
            staticClass: "st3",
            attrs: { cx: "78.5", cy: "9.5", r: "15.9" },
          }),
          _c("circle", {
            staticClass: "st3",
            attrs: { cx: "376", cy: "62", r: "15.9" },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              transform: "rotate(-13.928 100.506 59.452)",
              d: "M23.7 58.5h153.5v2H23.7z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: { d: "m183.9 43.6 30 79-1.8.7-30-79z" },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              transform: "rotate(-15.356 222.97 160.948)",
              d: "M222 119.5h2v83h-2z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              d: "m32.6 82.2 92 75-1.2 1.5-92-75zM215.6 120l.8 1.9-88 36-.8-1.9z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              transform: "rotate(-75.942 124.001 21.456)",
              d: "M123-30h2V72.9h-2z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              d: "M185 40h120v2H185zM303 45h2v104h-2zM373.3 62.3l1.5 1.3-63 75-1.6-1.3z",
            },
          }),
          _c("path", {
            staticClass: "st3",
            attrs: {
              transform: "rotate(-16.367 81.52 171.479)",
              d: "M37.2 170.5h88.6v2H37.2z",
            },
          }),
          _c("ellipse", {
            staticClass: "st2",
            attrs: { cx: "178", cy: "41", rx: "25.4", ry: "25.5" },
          }),
          _c("ellipse", {
            staticClass: "st2",
            attrs: { cx: "28", cy: "79", rx: "25.4", ry: "25.5" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "124.5", cy: "158.5", r: "15.9" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "39", cy: "184", r: "15.9" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "212", cy: "121", r: "15.9" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "302.5", cy: "41.5", r: "15.9" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "233", cy: "199", r: "15.9" },
          }),
        ]),
      ]),
      _c("g", { attrs: { transform: "matrix(1.53782 0 0 1.53796 925 425)" } }, [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_6_", d: "M-64-124h366v709H-64z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_7_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_6_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_7_)" } },
          [
            _c("path", {
              staticClass: "st2",
              attrs: {
                id: "R_shoe_1_-i2",
                d: "m102.6 427 12.2 34H28.6s4.4-8.5 19.2-14.8c14.8-6.3 28.5-19.2 28.5-19.2h26.3",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                id: "L_shoe_1_-i2",
                d: "m222.2 427 12.2 34h-86.3s4.4-8.5 19.2-14.8c14.8-6.3 28.5-19.2 28.5-19.2h26.4",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_hand_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-514.697",
                  y1: "-101.116",
                  x2: "-591.264",
                  y2: "-220.218",
                  gradientTransform: "matrix(.7295 0 0 .7296 408.582 174.272)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_hand_1_-i2_1_)" },
              attrs: {
                id: "L_hand_1_-i2",
                d: "M47.7 95.1S32.8 86 21.9 72.2 2.8 48.2 1.6 48.7s-3.2 3.1.5 8 6.7 8.4 4.4 11.4S-3.9 79.8 8.1 86s15.5 3.1 19.8 11.5c2.7 5.4 5.1 10.9 6.9 16.7l13-18.9",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_leg_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-490.031",
                  y1: "329.248",
                  x2: "-349.856",
                  y2: "64.631",
                  gradientTransform: "matrix(.7295 0 0 .7296 408.582 174.272)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: ".09" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: ".818" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_leg_1_-i2_1_)" },
              attrs: {
                id: "R_leg_1_-i2",
                d: "M145.8 231.8c-7.8 22.9-16.2 49.1-13 72.4s-3.5 36.2-6.4 42.6-3.5 21 1.9 41.6c5.5 20.6-3.2 38.5-3.2 38.5H76.2s1.3-77.4 2.5-117.2 3.3-49.4 6.8-61c3.4-11.7 14.1-77.9 14.1-77.9l7.5-.8c18.8 6.1 36.7 4.4 50.2 1.2 1.4 13.8-4.8 41.1-11.5 60.6z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_leg_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-331.459",
                  y1: "129.118",
                  x2: "-561.277",
                  y2: "-457.314",
                  gradientTransform: "matrix(.7295 0 0 .7296 408.582 174.272)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: ".09" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: ".818" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_leg_1_-i2_1_)" },
              attrs: {
                id: "L_leg_1_-i2",
                d: "M235.2 427h-39.3s-43.8-110.1-56.3-136.3-19.3-57.6-26.2-82.2c-3.7-12.9-6.6-26-8.6-39.3 23.1 8.2 45.1 4.5 59.5 0 1.9 5.1 9.3 26.2 9.3 48.3 0 25.5 7.5 46.6 14.3 57.8 8.5 13.7 14.1 29.1 16.5 45.1 3 19.5 9.8 22.5 18.8 36.8 8.9 14.4 20.1 51 12 69.8z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                id: "sweater_1_-i2",
                d: "M180.9 162.5s-43.8 24.9-87.4 1.8c0 0 16.8-91.7 17.6-104.5 0 0 12.5 2.7 17.1-8.7 0 .2 49.9 62.8 52.7 111.4z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                id: "L_sleeve_1_-i2",
                d: "M136.9 63.9c7.5 10.1 14.4 20.7 20.3 31.9.8 44.2-19.8 63.6-40.1 75.2-21 11.8-44.3 3.9-52.1-2.5-3.3-2.7-11.3-8.5-26.4-8.5-15.3 0-26.4-13-26.4-13l35.5-52c32.2 21.6 44.2 19 58.1 12.1 16.7-8.2 22.4-55.8 22.4-55.8 2.6 4.4 5.5 8.5 8.7 12.6z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck_1_-i2_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-398.26",
                  y1: "-137.082",
                  x2: "-393.914",
                  y2: "-210.344",
                  gradientTransform: "matrix(.7295 0 0 .7296 408.582 174.272)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck_1_-i2_1_)" },
              attrs: {
                id: "neck_1_-i2",
                d: "M128.2 51.3c-4.6 11.4-17.1 8.7-17.1 8.7.3-8 .4-18.5.2-21.1 4.2.9 8.5.8 12.6-.2.2 2.9 1.4 7.5 4.3 12.6z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#ffbeb6" },
              attrs: {
                id: "face_1_-i2",
                d: "M126.8 26.7c-1.2 4.9-3.2 8-2.9 12.9-5.2 1.4-15.5 1.5-19.4-3.6-3.8-4.8-2.7-9.9-3.9-10.3-1.2-.4-3.4-1.8-3.2-3.1.2-1.3 4.5-4.1 6.1-8.6.1-.4.3-.9.5-1.2 0 0 0-.1.1-.2 1.2-2.7 3-5 5.4-7 1.3.8 14.2 8.5 16.9 16.6.2.4.3 1 .3 1.5.4.9.3 2 .1 3z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#e94766" },
              attrs: {
                id: "hair_1_-i2",
                d: "M199.5 110.3c-3.5-5.9-8.7-9.2-13.5-13.8-9-8.5-2.4-20-3.7-30 .2-3.3-1-6.5-3.1-9-5.6-6.3-21.7-10-24.9-16.8-1.9-4.1-1.9-7.3-2-10.8 0-1.4 0-2.7-.2-4.2-.1-1.2-.2-2.4-.5-3.5-1.5-7.1-5.2-18.6-19.3-21.4-12-2.5-21 3.6-22.9 5.1 0 0 14.2 8 17 16.6.2.4.7 3.2.4 4.2-2.4 10-8.7 12.8 10.1 37.2s34.4 59.7 35.4 63.7h27.2s1.7-14.7-10-24.8-12.1-11.9-10-21.2c.5-2.4 1.2-4.7 1.6-7-1 6.8-2.7 13.7 1.6 19.7 3 4.1 7.8 6.5 11.3 10.2 5.8 6.2 9.3 14.4 9.9 22.9 0 .6 1 .6 1 0-.5-6.1-2.3-11.9-5.4-17.1z",
              },
            }),
            _c("path", {
              staticClass: "st2",
              attrs: {
                id: "texture_1_-i2",
                d: "M147.1 176.5c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1.1-.2 0-.3-.1-.3zm-4.9-2.1c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.2 0-.3-.1-.3zm-10.9 18c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.2.2.3.1.1 0 .2-.1.1-.3zm-2-4.9c0-.1-.1-.2-.2-.1-.1 0-.2.2-.1.3.1.1.2.2.3.1 0 0 .1-.2 0-.3zm-2.1-4.9c0-.1-.2-.2-.3-.1-.1.1-.2.2-.1.3 0 .1.2.2.3.1.1 0 .1-.1.1-.3zm-2-5c0-.1-.2-.2-.3-.1-.1.1-.2.2-.1.3 0 .1.2.2.3.1.1.1.1-.1.1-.3zm13.7 6.3c-.1-.1-.2-.1-.3 0s-.1.2 0 .3c.1.1.2.1.3 0 .2-.1.2-.3 0-.3zm-3.7-3.9c-.1-.1-.2-.1-.3 0l-.1.1c0 .1 0 .1.1.2h.2c.1 0 .1-.2.1-.3zm-3.9-3.8c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1.1.1-.1 0-.3zm-11.4 15.6c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2 0-.2-.2-.2zm0-5.4c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm32.8.5c-.2-.1-.4-.1-.5 0-.1.2-.1.4 0 .6.2.1.4.1.6 0 .1-.2 0-.5-.1-.6zm-7.6-6.7c-.2-.1-.4-.1-.6 0-.1.2-.1.4 0 .6.2.1.4.1.6 0 .1-.2.1-.4 0-.6zm-15.6 38.9c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.4-.4-.4zm-.8-10.1c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c.1-.3 0-.4-.4-.4zm-.6-10.1c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.4-.4-.4zm-.8-10.1c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c.1-.3-.1-.4-.4-.4zm-.6-10.1c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.5-.4-.4zm38-2.6c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5s.4 0 .5-.2.1-.5-.2-.5zm-9.5-3.2c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5s.4 0 .5-.2c.1-.2 0-.4-.2-.5zm-5.8 36.1c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5s.3.3.5.2c.3-.1.3-.3.2-.5zm-4.5-9c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.3.5.2.2-.1.3-.3.2-.5zm-4.6-9.2c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.3.5.2.2.1.4-.2.2-.5zm-4.5-9c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.3.5.2.2 0 .3-.3.2-.5zm-22.1 20.4c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5s.4-.1.5-.3c.1-.1 0-.3-.2-.4zm3.2-9.5c-.2-.1-.4 0-.5.2s0 .4.2.5c.2.1.4 0 .5-.2.1-.3 0-.5-.2-.5zm3.2-9.7c-.2-.1-.4.1-.5.3-.1.2 0 .4.2.5.2.1.4 0 .5-.2.2-.3.1-.5-.2-.6zm33.2 13.7c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.3-.4.1-.5zm-4.8-7.7c0-.1-.1-.1-.1-.1h-.3c-.2.1-.2.3-.1.5s.3.2.5.1c.1 0 .1-.1.1-.2s0-.2-.1-.3zm-4.8-7.6c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1.3-.4.1-.5zm-23.3 29.1c-.2 0-.4.1-.4.3 0 .2.1.4.2.4.2 0 .4-.1.4-.3.1-.2-.1-.4-.2-.4zm2-8.8c-.2 0-.4.1-.4.3 0 .2.1.4.2.4.2 0 .4-.1.4-.3.1-.2-.1-.4-.2-.4zm2-8.8c-.2 0-.4.1-.4.3-.1.2 0 .4.2.4s.4-.1.4-.3c.1-.2-.1-.4-.2-.4zm2-8.8c-.2 0-.4.1-.4.3 0 .2.1.4.3.4s.4-.1.4-.3c0-.2-.1-.4-.3-.4zm2-8.8c-.2 0-.4.1-.4.3 0 .2.1.4.3.4s.4-.1.4-.3c0-.2-.1-.4-.3-.4zm33.3 7.4c-.2-.1-.4-.1-.5.1-.1.1-.1.4.1.5.1.1.4.1.5-.1.1-.1 0-.3-.1-.5zm-7.4-5.2c-.2-.1-.4-.1-.5.1s-.1.4.1.5c.2.1.4.1.5-.1.1-.1.1-.4-.1-.5zm-14.7 29c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c-.1-.2-.2-.4-.4-.3zm-1.5-8.9c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.4-.4-.3zm-1.5-8.9c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.4-.4-.3zm-1.5-8.9c-.2 0-.3.2-.3.4 0 .1 0 .1.1.2s.2.1.3.1c.2 0 .3-.2.3-.4s-.2-.4-.4-.3zm-23.8 11.9c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2 0-.4-.1-.5zm46.1-9.6c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1 0 .1-.1 0-.3zm-3.6-3.8c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1-.1.1-.2 0-.3zm-3.7-3.9c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1-.1.1-.2 0-.3zM136.3 190c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.1-5.4c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.2-5.2c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm25-8.1c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3zm-14.7 14.2c0-.1-.1-.2-.2-.1-.1 0-.2.1-.1.3 0 .1.2.2.3.1 0-.1.1-.2 0-.3zm-1.8-5c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.2.2.3.1.1 0 .1-.2.1-.3zm-2-5c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.1.2.2.1.2-.1.3-.2.2-.3zm-16.7 9.3c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1.1.2 0 .3-.1.1-.1 0-.3-.1-.3zm2.2-4.8c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.3-.1-.3zm2.2-4.8c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1.1-.2 0-.3-.1-.3zm30.5 12.2c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.1 0 .2-.2.1-.3zm-3.3-5.1c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.2 0 .2-.1.1-.3zm-3.3-5.1c-.1-.1-.2-.1-.3-.1s-.1.2-.1.3c.1.1.2.1.3 0 .1 0 .3-.1.1-.2zm-18.8 14.6c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.1.1-.2-.1-.4-.2-.4zm1.3-5.9c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .3 0 .3-.2s-.1-.3-.2-.3zm1.3-6c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.2 0-.1-.1-.2-.2-.3zm1.3-5.9c-.1 0-.3.1-.3.2s0 .2.2.3c.1 0 .2 0 .3-.2 0-.2-.1-.3-.2-.3zm23.3-1.3c-.1-.1-.3-.1-.3.1-.1.1 0 .3.1.3.1.1.2 0 .3-.1 0 0 0-.2-.1-.3zm-14.5 16.4c0-.1-.1-.2-.3-.2-.1 0-.2.1-.2.3 0 .1.1.2.3.2h.1c.1-.1.2-.2.1-.3zm-1.3-6.2c-.1 0-.2.2-.2.3 0 .1.2.2.3.2.1 0 .2-.1.2-.3-.1-.1-.2-.2-.3-.2zm-1-6c-.1 0-.2.1-.2.3 0 .1.1.2.3.2.1 0 .2-.1.2-.3-.1-.1-.2-.2-.3-.2zm-20.6 7.2c-.1-.1-.2 0-.3.1-.1.1 0 .2.1.3.1.1.2.1.3 0 0-.1 0-.3-.1-.4zm3.6-5c-.1-.1-.3 0-.3.1-.1.1 0 .2.1.3.1.1.2.1.3 0 0-.1 0-.2-.1-.4zm28.3 35c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5.1-.2-.1-.3-.5-.3zm-1.6-10.3c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5 0-.2-.3-.3-.5-.3zm-1.6-10.3c-.2 0-.4.2-.3.4.1.2.2.4.4.3.2 0 .4-.2.3-.5.1-.1-.2-.3-.4-.2zm-1.6-10.3c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5-.1-.2-.3-.4-.5-.3zm-1.6-10.3c-.2 0-.4.2-.3.5 0 .2.2.4.4.3.2 0 .4-.2.3-.5 0-.2-.2-.4-.4-.3zm-36 31c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.2-.2.1-.5-.1-.6zm6.2-8.4c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6s.4.1.6-.1c.1-.2 0-.5-.1-.6zm6.2-8.5c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.4-.1-.6zm6.1-8.4c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.5-.1-.6zm32.4 5.9c-.1-.2-.4-.3-.6-.1-.2.1-.3.4-.1.6.1.2.4.3.6.1.2-.2.2-.4.1-.6zm-5.4-8.9c-.1-.2-.4-.3-.6-.1-.2.1-.2.4-.1.6.1.2.4.2.6.1.2-.2.2-.4.1-.6zm-23.4 33.1c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2 0 .4-.1.5-.3.1-.3 0-.5-.3-.5zm2.5-10.2c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2.1.4-.1.5-.3 0-.2-.1-.4-.3-.5zm2.4-10.1c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2.1.4-.1.5-.3.1-.3 0-.5-.3-.5zm2.4-10.2c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.2-.2 0-.4-.3-.5zm-.9 33.8c-.2 0-.4.1-.5.3-.1.2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.5-.3-.5zm1.9-10.2c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.1-.2 0-.5-.3-.5zm2.1-10.2c-.2 0-.4.1-.5.3-.1.2.1.4.3.5.2 0 .4-.1.5-.3.1-.2-.1-.4-.3-.5zm2-10.2c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5zm-24.9-5c-.1-.2-.4-.2-.5-.1-.2.1-.2.4-.1.5.1.2.4.2.6.1 0-.1.1-.3 0-.5zM161 186c-.2 0-.4.3-.3.5 0 .2.3.4.5.3.2 0 .4-.3.3-.5 0-.2-.2-.4-.5-.3zm-2.1-10.2c-.2 0-.4.3-.3.5.1.2.3.4.5.3.2 0 .3-.2.3-.5.1-.2-.1-.4-.5-.3zM126.3 199c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2 0-.4-.2-.6zm5.8-8.6c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.6.2.1.4.1.6-.1 0-.2 0-.5-.2-.6zm5.8-8.7c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.5-.1-.6zm5.7 12.5c-.1-.1-.3 0-.4.1-.1.2 0 .3.2.4s.3 0 .4-.2c0-.1 0-.3-.2-.3zm3.1-7.2c-.2-.1-.3 0-.4.1-.1.2 0 .3.2.4s.3 0 .4-.2c0-.1-.1-.3-.2-.3zm3.1-7.3c-.2-.1-.3 0-.4.2-.1.2 0 .3.2.4s.3 0 .4-.2c0-.1-.1-.3-.2-.4zm3-7.2c-.2-.1-.3 0-.4.2-.1.2 0 .3.2.4.1.1.3 0 .4-.1.1-.2 0-.4-.2-.5zm7.3 13.1c-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm.1-7.8c-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm-27.6 4.1c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1 0 .1-.3 0-.4zm5.6-5.4c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4s.3.1.4 0c.1-.1.1-.3 0-.4zm24.1-.3c-.1 0-.2 0-.2.1s0 .2.1.2.2-.1.2-.1-.1 0-.1-.2zm.6-4.1c-.1 0-.2 0-.2.1s0 .2.1.2.2 0 .2-.1c.1-.1 0-.2-.1-.2zm-5.7 10.9c-.1-.1-.3 0-.4.1-.1.1-.1.3.1.3.1.1.3.1.4-.1.1-.1.1-.2-.1-.3zm3.8-6c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.2.1-.3-.1-.4.1 0 .1 0 0 0zm3.8-6c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.1.1-.3-.1-.4z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#1c2868" },
              attrs: {
                id: "lips_1_-i2",
                d: "M107 29c-1.3 1.8-3.8 2.4-5.6 1.2-.6-.4-1.2-1.1-1.5-1.8-.2-.5.6-1.1.9-.4.5 1.6 2.4 2.5 4 1.8.6-.2 1.1-.6 1.5-1.2.2-.5 1.1 0 .7.4z",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }